const OAUTH_ERRORS_THAT_MEAN_THE_REFRESH_TOKEN_IS_DEAD: readonly string[] = [
  'invalid_grant',
  'invalid_client',
  'unauthorized_client',
];

export function isTerminalOAuthErrorCode(code: string | null | undefined): boolean {
  return code != null && OAUTH_ERRORS_THAT_MEAN_THE_REFRESH_TOKEN_IS_DEAD.includes(code);
}
